/**
 * tdesign v0.21.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-0b4c3c44.mjs';
import { defineComponent, inject, h, watch, onMounted, onUnmounted, createVNode } from 'vue';
import { ANCHOR_SHARP_REGEXP } from './utils.mjs';
import props from './anchor-item-props.mjs';
import { usePrefixClass, useCommonClassName } from '../hooks/useConfig.mjs';
import { AnchorInjectionKey } from './constants.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-bfb23a5e.mjs';
import '../_chunks/dep-a48de419.mjs';
import '../_chunks/dep-2a7dc5c7.mjs';
import '../_chunks/dep-9311bf66.mjs';
import '../_chunks/dep-4889eb51.mjs';
import '../_chunks/dep-0b4185fe.mjs';
import '../_chunks/dep-3ca5fb38.mjs';
import '../_chunks/dep-7071345f.mjs';
import '../_chunks/dep-d2403b2f.mjs';
import '../_chunks/dep-7922050a.mjs';
import '../_chunks/dep-169ea640.mjs';
import '../_chunks/dep-f6b25712.mjs';
import '../_chunks/dep-59545a4d.mjs';
import '../_chunks/dep-c27b1c14.mjs';
import '../_chunks/dep-7d96367f.mjs';
import '../_chunks/dep-827c4600.mjs';
import '../_chunks/dep-0820e0e2.mjs';
import '../_chunks/dep-caad2e91.mjs';
import '../_chunks/dep-3d4aad09.mjs';
import '../_chunks/dep-8e38f523.mjs';
import '../_chunks/dep-469bf54b.mjs';
import '../_chunks/dep-8ef9fb8e.mjs';
import '../_chunks/dep-e769aafd.mjs';
import '../_chunks/dep-400798c5.mjs';
import '../_chunks/dep-361522ee.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../config-provider/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var localProps = _objectSpread(_objectSpread({}, props), {}, {
  href: {
    type: String,
    required: true,
    validator: function validator(v) {
      return ANCHOR_SHARP_REGEXP.test(v);
    }
  }
});

var _AnchorItem = defineComponent({
  name: "TAnchorItem",
  inject: {
    tAnchor: {
      "default": void 0
    }
  },
  props: localProps,
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var anchor = inject(AnchorInjectionKey, void 0);
    var CLASSNAME_PREFIX = usePrefixClass("anchor__item");

    var _useCommonClassName = useCommonClassName(),
        STATUS = _useCommonClassName.STATUS;

    var register = function register() {
      anchor.registerLink(props2.href);
    };

    var unregister = function unregister() {
      var href = props2.href;
      if (!href) return;
      anchor.unregisterLink(href);
    };

    var handleClick = function handleClick(e) {
      var href = props2.href,
          title = props2.title;
      anchor.handleScrollTo(href);
      anchor.handleLinkClick({
        href: href,
        title: typeof title === "string" ? title : void 0,
        e: e
      });
    };

    var renderTitle = function renderTitle() {
      var title = props2.title;
      var titleSlot = slots.title;
      var titleVal;

      if (typeof title === "string") {
        titleVal = title;
      } else if (typeof title === "function") {
        titleVal = title(h);
      } else if (titleSlot) {
        titleVal = titleSlot(null);
      }

      return titleVal;
    };

    watch(function () {
      return props2.href;
    }, function () {
      unregister();
      register();
    }, {
      immediate: true
    });
    onMounted(function () {
      register();
    });
    onUnmounted(function () {
      register();
    });
    return function () {
      var _wrapperClass;

      var href = props2.href,
          target = props2.target;
      var children = slots["default"],
          titleSlot = slots.title;
      var title = renderTitle();
      var titleAttr = typeof title === "string" ? title : null;
      var active = anchor.active === href;
      var wrapperClass = (_wrapperClass = {}, _defineProperty(_wrapperClass, CLASSNAME_PREFIX.value, true), _defineProperty(_wrapperClass, STATUS.value.active, active), _wrapperClass);

      var titleClass = _defineProperty({}, "".concat(CLASSNAME_PREFIX.value, "-link"), true);

      return createVNode("div", {
        "class": wrapperClass
      }, [createVNode("a", {
        "href": href,
        "title": titleAttr,
        "class": titleClass,
        "target": target,
        "onClick": handleClick
      }, [titleSlot ? titleSlot(null) : title]), children && children(null)]);
    };
  }
});

export { _AnchorItem as default };
//# sourceMappingURL=anchor-item.mjs.map
